import translate from "@/i18n/translate";
import "./Header.scss";
import { useContext, useReducer, useEffect } from "react";
import { AppContext, AppContextInterface } from "../../../contexts/AppContext";
import { Institution, Organization } from "../interfaces/Interface";

const { REDIRECT_URI } = runConfig;

function getOrganizationType(orgType: string | undefined) {
  return orgType ? orgType[0].toUpperCase() + orgType.slice(1) : "Institution";
}

function getPlanningUrl(
  organization: Organization | null | undefined,
  institution: Institution | null
): string {
  let orgUuid = (organization && organization.uuid) || institution?.rootOrgUuid;

  return orgUuid
    ? `${REDIRECT_URI}/org-identity/${orgUuid}`
    : `${REDIRECT_URI}`;
}

export interface PssSideNavProps {
  organization?: Organization | null;
  pssOrganization: Organization;
}
export default function PssSideNav({
  organization,
  pssOrganization
}: PssSideNavProps): JSX.Element {
  const { institution } = useContext<AppContextInterface>(AppContext);

  const planningURI =
    pssOrganization || institution
      ? getPlanningUrl(pssOrganization, institution)
      : "";

  const organizationType = organization?.type || pssOrganization.type;
  const sideNavBody = () => {
    let orgType = getOrganizationType(pssOrganization.type);
    return (
      <div id="new-side-nav" className="org-side-nav">
        <div className="nav-main">
          <nav id="sidemainnav" className="main-nav-org side-navs item-9">
            <ul id="sidenavmenu" className="menu">
              <li className="menuitem active-parent">
                <a
                  id="insights-nav"
                  tabIndex={0}
                  className="navlinks active"
                >
                  <div className="flex-row -verticallycentered -option">
                    <div className="-icons mdi mdi-chart-bar"></div>
                    <div className="menuname -name">Insights</div>
                  </div>
                </a>
              </li> 
              <li className="menuitem">
                <a
                  href={planningURI + `?tab=inProgress`}
                  id="in-progress-nav"
                  tabIndex={0}
                  className="navlinks"
                >
                  <div className="flex-row -verticallycentered -option">
                    <div
                      className="-icons mdi mdi-folder-edit-outline "
                      aria-hidden={true}
                    ></div>
                    <div className="menuname -name ">
                      {translate("app.sidenav.inProgress")}
                    </div>
                  </div>
                </a>
              </li>
              <li className="menuitem">
                <a
                  href={planningURI + `?tab=outcomes`}
                  id="insitution-info-nav"
                  tabIndex={0}
                  className="navlinks"
                >
                  <div className="flex-row -verticallycentered -option">
                    <div className="-icons mdi mdi-information-outline"></div>
                    <div className="menuname -name ">
                      {translate("app.sidenav.orgTypeInformation", {
                        orgType: orgType
                      })}
                    </div>
                  </div>
                </a>
              </li>
              {institution &&
                renderCurriculumMenu(
                  institution.showCurriculumTab,
                  planningURI,
                  organizationType
                )}
              <li className="menuitem">
                <a
                  href={planningURI + `?tab=actions`}
                  id="actions-nav"
                  tabIndex={0}
                  className="navlinks"
                >
                  <div className="flex-row -verticallycentered -option">
                    <div className="-icons mdi mdi-checkbox-marked-circle-outline"></div>
                    <div className="menuname -name ">
                      {translate("app.sidenav.actions")}
                    </div>
                  </div>
                </a>
              </li>
              <li className="menuitem">
                <a
                  href={planningURI + `?tab=docs`}
                  id="docs-reports-nav"
                  tabIndex={0}
                  className="navlinks"
                >
                  <div className="flex-row -verticallycentered -option">
                    <div
                      className="-icons mdi mdi-file-document-box-multiple-outline"
                      aria-hidden={true}
                    ></div>
                    <div className="menuname -name ">
                      {translate("app.sidenav.docs&Reports")}
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    );
  };
  const renderCurriculumMenu = (
    showCurriculumMenu: boolean,
    planningURI: string,
    organizationType: string | undefined
  ) => {
    if (showCurriculumMenu || organizationType === "program") {
      return (
        <li className="menuitem">
          <a
            href={planningURI + `?tab=curriculum`}
            id="curriculum-nav"
            tabIndex={0}
            className="navlinks"
          >
            <div className="flex-row -verticallycentered -option">
              <div
                className="-icons mdi mdi-book-outline"
                aria-hidden={true}
              ></div>
              <div className="menuname -name ">
                {translate("app.sidenav.curriculum")}
              </div>
            </div>
          </a>
        </li>
      );
    }
  };

  return <>{sideNavBody()}</>;
}
